/**
 * @generated SignedSource<<cf7edc4f5a6289a7c2798a11c0d3f2bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSplit_address$data = {
  readonly address: string | null;
  readonly ensDomain: string | null;
  readonly publicProfile: {
    readonly avatarImage: {
      readonly path: string | null;
    } | null;
    readonly displayName: string | null;
  } | null;
  readonly split: {
    readonly allocations: ReadonlyArray<{
      readonly address: {
        readonly address: string | null;
        readonly ensDomain: string | null;
        readonly publicProfile: {
          readonly avatarImage: {
            readonly path: string | null;
          } | null;
          readonly displayName: string | null;
        } | null;
      } | null;
      readonly allocation: number | null;
      readonly basisPoints: number | null;
    } | null> | null;
    readonly bookmark?: {
      readonly name: string | null;
    } | null;
    readonly controllerAddress: {
      readonly address: string | null;
      readonly ensDomain: string | null;
    } | null;
    readonly distributorFee: string | null;
  } | null;
  readonly " $fragmentType": "useSplit_address";
};
export type useSplit_address$key = {
  readonly " $data"?: useSplit_address$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSplit_address">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ensDomain",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchSplitName"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSplit_address",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NftSplit",
      "kind": "LinkedField",
      "name": "split",
      "plural": false,
      "selections": [
        {
          "condition": "fetchSplitName",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "userId",
                  "variableName": "userId"
                }
              ],
              "concreteType": "NftSplitBookmark",
              "kind": "LinkedField",
              "name": "bookmark",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "distributorFee",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "controllerAddress",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftSplitAllocation",
          "kind": "LinkedField",
          "name": "allocations",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allocation",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "basisPoints",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EthereumAddressType",
              "kind": "LinkedField",
              "name": "address",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EthereumAddressType",
  "abstractKey": null
};
})();

(node as any).hash = "cfc02c6448544a0850ad0ecf5b8d81b5";

export default node;
